import { NavLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Home, Puzzle, Vault, Settings } from 'lucide-react'
import { cn } from '@/lib/utils'

const items = [
  { to: '/', labelKey: 'nav.home', icon: Home, end: true },
  { to: '/vaults', labelKey: 'nav.vaultsShort', icon: Vault },
  { to: '/extension', labelKey: 'nav.extensionShort', icon: Puzzle },
  { to: '/settings', labelKey: 'nav.settings', icon: Settings },
]

export function BottomNav() {
  const { t } = useTranslation()

  return (
    <nav className="fixed inset-x-0 bottom-0 z-40 border-t bg-background/95 backdrop-blur md:hidden">
      <ul className="grid grid-cols-4">
        {items.map((it) => {
          const Icon = it.icon
          return (
            <li key={it.to}>
              <NavLink
                to={it.to}
                end={it.end}
                className={({ isActive }) =>
                  cn(
                    'flex flex-col items-center gap-0.5 py-2 text-xs',
                    isActive ? 'text-primary' : 'text-muted-foreground hover:text-foreground',
                  )
                }
              >
                <Icon className="h-5 w-5" />
                {t(it.labelKey)}
              </NavLink>
            </li>
          )
        })}
      </ul>
    </nav>
  )
}
